import * as React from 'react';

import { DateRangePicker, Button } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { $columnDateRange } from '../../../_state/brokeredLoadsList.state';
import { useTranslations } from '../../../i18n/useTranslations';

interface DateRangeColumnFilterProps {
  onClose?: () => void;
}

export const DateRangeColumnFilter: React.FC<DateRangeColumnFilterProps> = ({
  onClose,
}) => {
  const t = useTranslations();
  const [dateRange, setDateRange] = useAtom($columnDateRange);

  const handleReset = React.useCallback(() => {
    setDateRange(null);
  }, [setDateRange]);

  return (
    <div className="@DateRangeColumnFilter flex min-w-[300px] flex-col gap-3 p-3">
      <DateRangePicker
        value={dateRange}
        onChange={setDateRange}
        label={t.brokerage.loads.columnFilters.dateRange.label}
        aria-label={t.brokerage.loads.columnFilters.dateRange.aria}
      />

      <div className="flex justify-end gap-2">
        <Button
          variant="outline"
          onPress={handleReset}
          color="neutral"
          isDisabled={!dateRange}
        >
          {t.brokerage.loads.columnFilters.dateRange.clear}
        </Button>
        <Button variant="solid" onPress={onClose}>
          {t.brokerage.loads.columnFilters.dateRange.done}
        </Button>
      </div>
    </div>
  );
};
